import AuthorisedSwitch from "components/AuthorisedSwitch";
import WarningPopup from "components/WarningPopup";
import { useCallback, useEffect, useState } from "react";
import ModalUtil from "utils/modalUtil";
import React from "react";
import { CellRenderers, startCaseWithSpace, getFilterProps } from "utils/tableUtils";
import { PermissionSetMap } from "constants/RBACConstants";

const startCaseWithSpaceWithNullSupport = (text, value) => {
    if(value === null){
        return text;
    }
    return startCaseWithSpace(text);
}

export const generateScanStatusColumn = (data, otherColumProps) => ({
    title: "Last Scan Status",
    dataIndex: "scanStatus",
    ...otherColumProps,
    render: CellRenderers.SCAN_STATUS,
    ...getFilterProps({ dataIndex: "scanStatus", dataSource: data, filterLabelFormatter: startCaseWithSpaceWithNullSupport, nullFilterValue: null })
})

export const generateOperationalStatusColumn = (data, width) => ({
    title: "Tool Status",
    dataIndex: "operationalStatus",
    width,
    render: (text, record) => {
        return CellRenderers.OPERATIONAL_STATUS(text, record);
    },
    ...getFilterProps({ dataIndex: "operationalStatus", dataSource: data, filterLabelFormatter: getOperationalStatusFilterText })
})

export function getOperationalStatusFilterText(text){
    if (text === "CONFIG_ERROR") {
        text = "error";
    }
    return startCaseWithSpace(text);
}

export const PullToolSuspendSwitch = ({ text, record, suspendAPI, onUpdateConfigComponent, tableRef }) => {
    const [suspended, setSuspended] = useState(record.suspended);
    useEffect(() => {
        setSuspended(record.suspended)
    }, [record.suspended]);
    const onSuspend = useCallback((reason) => {
        if (suspendAPI) {
            const { promise } = suspendAPI({
                id: record.id,
                tool_name: record.tool_name,
                suspended: !suspended,
                reason,
            })
            return promise.then(() => {
                onUpdateConfigComponent();
                tableRef.current.refresh();
                tableRef.current.refreshFilters();
            });
        }
    }, [suspendAPI, suspended, onUpdateConfigComponent, record.id, record.tool_name,tableRef])

    const confirmPopUp = useCallback(() => {
        ModalUtil.show({
            content: <WarningPopup
                type=""
                title={`Are you sure you want to ${!suspended ? "disable?" : "enable?"}`}
                onOk={onSuspend} note />
        })
    }, [suspended, onSuspend]);

    return (<AuthorisedSwitch permission={PermissionSetMap.EDIT_TOOL_CONFIG} defaultChecked={!text} checked={!suspended} onClick={confirmPopUp} size="small" />)
}

export const IntegrationType = {
    PULL: "PULL",
    PUSH: "PUSH",
    WEBHOOK: "WEBHOOK"
}
